export default __webpack_public_path__ + "e8a11a9af0dc60398b561f21e81c352d.png";